import React from "react"
import PropTypes from "prop-types"
import DynamicImageViewer from "./DynamicImageViewer"

const AuthorCard = ({ data }) => {
  const {
    author: {
      name: name,
      title: title,
      description: description,
      image: image,
    },
  } = data

  return (
    <div
      className={`sm:flex xl:flex-col p-4 bg-gray-100 sm:space-x-8 xl:space-x-0`}
    >
      {/*圖片.Tilte*/}
      <div className={`text-center relative space-y-4 basis-1/4`}>
        <DynamicImageViewer
          alt={name}
          image={image}
          className={`rounded-full absolute left-1/2 transform -translate-x-1/2 top-0 -mt-20 sm:-mt-16 h-[88px] w-[88px]`}
        />
        <div className={`grid gap-2 py-4`}>
          <p>{name}</p>
          <p>{title}</p>
        </div>
      </div>
      {/*作者介紹*/}
      <div
        className={`pt-4 border-t-2 border-t-gray-300 basis-3/4 sm:border-none xl:border-t-2 xl:border-t-gray-300`}
      >
        {description?.description}
      </div>
    </div>
  )
}

AuthorCard.propTypes = {
  data: PropTypes.object,
}
export default AuthorCard
